export const LOGIN_LOADING = "LOGIN_LOADING";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_ERROR = "LOGIN_ERROR";
export const LOGOUT_USER = "LOGOUT_USER";
export const LOGIN_SETUSUARIO = "LOGIN_SETUSUARIO";

export const MODAL_HIDE = "MODAL_HIDE";
export const MODAL_SHOW = "MODAL_SHOW";

export const BENEFICIOS_SET = "BENEFICIOS_SET";

export const MODALSEGUNDO_HIDE = "MODALSEGUNDO_HIDE";
export const MODALSEGUNDO_SHOW = "MODALSEGUNDO_SHOW";

export const EDITANDO_PERFIL = "EDITANDO_PERFIL";
export const FINALIZAEDICION_PERFIL = "FINALIZAEDICION_PERFIL";

export const AYUDA_HIDE = "AYUDA_HIDE";
export const AYUDA_SHOW = "AYUDA_SHOW";

export const LOCALIDAD_LOADING = "LOCALIDAD_LOADING";
export const LOCALIDAD_SUCCESS = "LOCALIDAD_SUCCESS";
export const LOCALIDAD_ERROR = "LOCALIDAD_ERROR";
export const LOCALIDAD_RESET = "LOCALIDAD_RESET";

export const FAMILIARES_LOADING = "FAMILIARES_LOADING";
export const FAMILIARES_SUCCESS = "FAMILIARES_SUCCESS";
export const FAMILIARES_ERROR = "FAMILIARES_ERROR";

export const TURNO_SALDADO_LOADING = "TURNO_SALDADO_LOADING";
export const TURNO_SALDADO_SUCCESS = "TURNO_SALDADO_SUCCESS";
export const TURNO_SALDADO_ERROR = "TURNO_SALDADO_ERROR";
export const TURNO_SALDADO_RESET = "TURNO_SALDADO_RESET";

export const LISTAFAMILIARES_LOADING = "FAMILIARES_LOADING";
export const LISTAFAMILIARES_SUCCESS = "FAMILIARES_SUCCESS";
export const LISTAFAMILIARES_ERROR = "FAMILIARES_ERROR";
export const LISTAFAMILIARES_RESET = "LISTAFAMILIARES_RESET";

export const OBRASOCIAL_LOADING = "OBRASOCIAL_LOADING";
export const OBRASOCIAL_SUCCESS = "OBRASOCIAL_SUCCESS";
export const OBRASOCIAL_ERROR = "OBRASOCIAL_ERROR";

export const PLAN_OS_LOADING = "PLAN_OS_LOADING";
export const PLAN_OS_SUCCESS = "PLAN_OS_SUCCESS";
export const PLAN_OS_ERROR = "PLAN_OS_ERROR";
export const PLAN_OS_RESET = "PLAN_OS_RESET";

export const VERIFICADNI_LOADING = "VERIFICADNI_LOADING";
export const VERIFICADNI_SUCCESS = "VERIFICADNI_SUCCESS";
export const VERIFICADNI_ERROR = "VERIFICADNI_ERROR";
export const VERIFICADNI_LOGOUT = "VERIFICADNI_LOGOUT";

export const REGISTRO_LOADING = "REGISTRO_LOADING";
export const REGISTRO_SUCCESS = "REGISTRO_SUCCESS";
export const REGISTRO_ERROR = "REGISTRO_ERROR";
export const REGISTRO_SETUSUARIO = "REGISTRO_SETUSUARIO";
export const REGISTRO_LOGOUT = "REGISTRO_LOGOUT";
export const REGISTRO_SETERRORUSUARIO = "REGISTRO_SETERRORUSUARIO";

export const VALIDAMOBILE_LOADING = "VALIDAMOBILE_LOADING";
export const VALIDAMOBILE_SUCCESS = "VALIDAMOBILE_SUCCESS";
export const VALIDAMOBILE_ERROR = "VALIDAMOBILE_ERROR";
export const VALIDAMOBILE_LOGOUT = "VALIDAMOBIE_LOGOUT";

export const MULTITAB_SETPASO = "MULTITAB_SETPASO";
export const MULTITAB_SETORIGEN = "MULTITAB_SETORIGEN";
export const MULTITAB_LOGOUT = "MULTITAB_LOGOUT";

export const CAMBIOCLAVE_LOADING = "CAMBIOCLAVE_LOADING";
export const CAMBIOCLAVE_SUCCESS = "CAMBIOCLAVE_SUCCESS";
export const CAMBIOCLAVE_ERROR = "CAMBIOCLAVE_ERROR";
export const CAMBIOCLAVE_LOGOUT = "CAMBIOCLAVE_LOGOUT";

export const PACIENTE_LOADING = "PACIENTE_LOADING";
export const PACIENTE_SUCCESS = "PACIENTE_SUCCESS";
export const PACIENTE_ERROR = "PACIENTE_ERROR";
export const PACIENTE_LOGOUT = "PACIENTE_LOGOUT";
export const PACIENTE_EDITAR = "PACIENTE_EDITAR";
export const EDITANDO_PACIENTE = "EDITANDO_PACIENTE";
export const GETDATOSPACIENTE_SUCCESS = "GETDATOSPACIENTE_SUCCESS";
export const RESET_PACIENTE = "RESET_PACIENTE";
export const PACIENTE_CAMBIOCLAVE = "PACIENTE_CAMBIOCLAVE";
export const PACIENTE_EDITACLAVE = "PACIENTE_EDITACLAVE";
export const PACIENTE_BIOSEGURIDAD = "PACIENTE_BIOSEGURIDAD";
export const PACIENTE_BIOSEGURIDAD_ERROR = "PACIENTE_BIOSEGURIDAD_ERROR";
export const FINALIZAEDICION_PACIENTE = "FINALIZAEDICION_PACIENTE";

export const GETDATOSPACIENTE_LOADING = "GETDATOSPACIENTE_LOADING";

export const GETDATOSPACIENTE_ERROR = "GETDATOSPACIENTE_ERROR";
export const GETDATOSPACIENTE_RESET = "GETDATOSPACIENTE_RESET";

export const PORTALEXTERIOR_LOADING = "PORTALEXTERIOR_LOADING";
export const PORTALEXTERIOR_SUCCESS = "PORTALEXTERIOR_SUCCESS";
export const PORTALEXTERIOR_ERROR = "PORTALEXTERIOR_ERROR";
export const PORTALEXTERIOR_RESET = "PORTALEXTERIOR_RESET";

export const ALTAPROTOCOLOPCR_LOADING = "ALTAPROTOCOLOPCR_LOADING";
export const ALTAPROTOCOLOPCR_SUCCESS = "ALTAPROTOCOLOPCR_SUCCESS";
export const ALTAPROTOCOLOPCR_ERROR = "ALTAPROTOCOLOPCR_ERROR";
export const ALTAPROTOCOLOPCR_RESET = "ALTAPROTOCOLOPCR_RESET";

export const HASH_LOADING = "HASH_LOADING";
export const HASH_SUCCESS = "HASH_SUCCESS";
export const HASH_ERROR = "HASH_ERROR";
export const HASH_LOGOUT = "HASH_LOGOUT";

export const TOKEN_LOADING = "TOKEN_LOADING";
export const TOKEN_SUCCESS = "TOKEN_SUCCESS";
export const TOKEN_ERROR = "TOKEN_ERROR";
export const TOKEN_LOGOUT = "TOKEN_LOGOUT";

export const VCTOKEN_LOADING = "VCTOKEN_LOADING";
export const VCTOKEN_SUCCESS = "VCTOKEN_SUCCESS";
export const VCTOKEN_ERROR = "VCTOKEN_ERROR";
export const VCTOKEN_RESET = "VCTOKEN_RESET";

export const TOKENFCM_LOADING = "TOKENFCM_LOADING";
export const TOKENFCM_SUCCESS = "TOKENFCM_SUCCESS";
export const TOKENFCM_ERROR = "TOKENFCM_ERROR";
export const TOKENFCM_RESET = "TOKENFCM_RESET";
export const SET_NEW_TOKENFCM = "SET_NEW_TOKENFCM";

export const ESTUDIOGRUPO_LOADING = "ESTUDIOGRUPO_LOADING";
export const ESTUDIOGRUPO_SUCCESS = "ESTUDIOGRUPO_SUCCESS";
export const ESTUDIOGRUPO_ERROR = "ESTUDIOGRUPO_ERROR";
export const ESTUDIOMASBUSCADO_LOADING = "ESTUDIOMASBUSCADO_LOADING";
export const ESTUDIOMASBUSCADO_SUCCESS = "ESTUDIOMASBUSCADO_SUCCESS";
export const ESTUDIOMASBUSCADO_ERROR = "ESTUDIOMASBUSCADO_ERROR";
export const ESTUDIOMASBUSCADO_RESET = "ESTUDIOMASBUSCADO_RESET";
export const ESTUDIOGRUPO_RESET = "ESTUDIOGRUPO_RESET";
export const ESTUDIOGRUPO_FILTRAR_POR_EDAD = "ESTUDIOGRUPO_FILTRAR_POR_EDAD";

export const LABOGRUPO_LOADING = "LABOGRUPO_LOADING";
export const LABOGRUPO_SUCCESS = "LABOGRUPO_SUCCESS";
export const LABOGRUPO_CENTROS = "LABOGRUPO_CENTROS";
export const LABOGRUPO_ERROR = "LABOGRUPO_ERROR";
export const LABOGRUPO_RESET = "LABOGRUPO_RESET";

export const LABOTURNOS_LOADING = "LABOTURNOS_LOADING";
export const LABOTURNOS_SUCCESS = "LABOTURNOS_SUCCESS";
export const LABOTURNOS_ERROR = "LABOTURNOS_ERROR";
export const LABOTURNOS_LOGOUT = "LABOTURNOS_LOGOUT";
export const LABOTURNOS_MATRICULAMEDICO = "LABOTURNOS_MATRICULAMEDICO";
export const LABOTURNOS_FLG_CAMBIARTURNO = "LABOTURNOS_FLG_CAMBIARTURNO";
export const LABOTURNOS_FLG_BUSCARTURNOLABO = "LABOTURNOS_FLG_BUSCARTURNOLABO";

export const MISMEDICOS_LOADING = "MISMEDICOS_LOADING";
export const MISMEDICOS_SUCCESS = "MISMEDICOS_SUCCESS";
export const MISMEDICOS_ERROR = "MISMEDICOS_ERROR";
export const MISMEDICOS_RESET = "MISMEDICOS_RESET";
export const MISMEDICOS_ALTAENCUESTA = "MISMEDICOS_ALTAENCUESTA";
export const MISMEDICOS_RESETENCUESTA = "MISMEDICOS_RESETENCUESTA";
export const MISMEDICOS_FLGRECARGAR = "MISMEDICOS_FLGRECARGAR";
export const MISMEDICOS_FLGRECARGAR_RESET = "MISMEDICOS_FLGRECARGAR_RESET";

export const MISLABORATORIOS_LOADING = "MISLABORATORIOS_LOADING";
export const MISLABORATORIOS_SUCCESS = "MISLABORATORIOS_SUCCESS";
export const MISLABORATORIOS_ERROR = "MISLABORATORIOS_ERROR";
export const MISLABORATORIOS_RESET = "MISLABORATORIOS_RESET";
export const MISLABORATORIOS_ARCHIVOBASE64LABO =
  "MISLABORATORIOS_ARCHIVOBASE64LABO";
export const MISLABORATORIOS_RESET_ARCHIVOBASE64LABO =
  "MISLABORATORIOS_RESET_ARCHIVOBASE64LABO";

export const MISINFORMES_LOADING = "MISINFORMES_LOADING";
export const MISINFORMES_SUCCESS = "MISINFORMES_SUCCESS";
export const MISINFORMES_ERROR = "MISINFORMES_ERROR";
export const MISINFORMES_RESET = "MISINFORMES_RESET";
export const MISINFORMES_ARCHIVOBASE64 = "MISINFORMES_ARCHIVOBASE64";
export const MISINFORMES_VISUALIZARIMAGEN = "MISINFORMES_VISUALIZARIMAGEN";
export const MISINFORMES_RESET_VISUALIZARIMAGEN =
  "MISINFORMES_RESET_VISUALIZARIMAGEN";
export const MISINFORMES_RESET_ARCHIVOBASE64 =
  "MISINFORMES_RESET_ARCHIVOBASE64";

export const CANCELACION_LOADING = "CANCELACION_LOADING";
export const CANCELACION_SUCCESS = "CANCELACION_SUCCESS";
export const CANCELACION_ERROR = "CANCELACION_ERROR";
export const CANCELACION_VALIDACANCELA = "CANCELACION_VALIDACANCELA";
export const CANCELACION_RESET = "CANCELACION_RESET";

export const MOTIVOCANCELACION_LOADING = "MOTIVOCANCELACION_LOADING";
export const MOTIVOCANCELACION_SUCCESS = "MOTIVOCANCELACION_SUCCESS";
export const MOTIVOCANCELACIONLABORATORIO_SUCCESS =
  "MOTIVOCANCELACIONLABORATORIO_SUCCESS";
export const MOTIVOCANCELACION_ERROR = "MOTIVOCANCELACION_ERROR";
export const MOTIVOCANCELACION_RESET = "MOTIVOCANCELACION_RESET";

export const RECETADIGITAL_LOADING = "RECETADIGITAL_LOADING";
export const RECETADIGITAL_SUCCESS = "RECETADIGITAL_SUCCESS";
export const RECETADIGITAL_ERROR = "RECETADIGITAL_ERROR";
export const RECETADIGITAL_RESET = "RECETADIGITAL_RESET";
export const RECETADIGITAL_SETERRORUSUARIO = "RECETADIGITAL_SETERRORUSUARIO";
export const RECETADIGITAL_SETRECETA = "RECETADIGITAL_SETRECETA";

export const CERTIFICADO_LOADING = "CERTIFICADO_LOADING";
export const CERTIFICADO_SUCCESS = "CERTIFICADO_SUCCESS";
export const CERTIFICADO_ERROR = "CERTIFICADO_ERROR";
export const CERTIFICADO_RESET = "CERTIFICADO_RESET";

export const ESTUDIOTURNOS_LOADING = "ESTUDIOTURNOS_LOADING";
export const ESTUDIOTURNOS_SUCCESS = "ESTUDIOTURNOS_SUCCESS";
export const ESTUDIOTURNOS_ERROR = "ESTUDIOTURNOS_ERROR";
export const ESTUDIOTURNOS_LOGOUT = "ESTUDIOTURNOS_LOGOUT";
export const ESTUDIOTURNOS_SETCIRCUITORESO = "ESTUDIOTURNOS_SETCIRCUITORESO";
export const ESTUDIOTURNOS_SETCIRCUITOTOMO = "ESTUDIOTURNOS_SETCIRCUITOTOMO";

export const CONSULTAMEDTURNOS_LOADING = "CONSULTAMEDTURNOS_LOADING";
export const CONSULTAMEDTURNOS_SUCCESS = "CONSULTAMEDTURNOS_SUCCESS";
export const CONSULTAMEDTURNOS_ERROR = "CONSULTAMEDTURNOS_ERROR";
export const CONSULTAMEDTURNOS_LOGOUT = "CONSULTAMEDTURNOS_LOGOUT";

export const TOKENGOOGLE_ERROR = "TOKENGOOGLE_ERROR";
export const TOKENGOOGLE_LOADING = "TOKENGOOGLE_LOADING";
export const TOKENGOOGLE_SUCCESS = "TOKENGOOGLE_SUCCESS";
export const TOKENGOOGLE_LOGOUT = "TOKENGOOGLE_SUCCESS";

export const TEXTOS_LOADING = "TEXTOS_LOADING";
export const TEXTOS_SUCCESS = "TEXTOS_SUCCESS";
export const TEXTOS_ERROR = "TEXTOS_ERROR";
export const TEXTOS_LOGOUT = "TEXTOS_LOGOUT";

export const SUGERENCIA_LOADING = "SUGERENCIA_LOADING";
export const SUGERENCIA_SUCCESS = "SUGERENCIA_SUCCESS";
export const SUGERENCIA_ERROR = "SUGERENCIA_ERROR";
export const SUGERENCIA_RESET = "SUGERENCIA_RESET";

export const ENVIARMAIL_LOADING = "ENVIARMAIL_LOADING";
export const ENVIARMAIL_SUCCESS = "ENVIARMAIL_SUCCESS";
export const ENVIARMAIL_ERROR = "ENVIARMAIL_ERROR";
export const ENVIARMAIL_RESET = "ENVIARMAIL_RESET";

export const ATENCIONSINTURNO_LOADING = "ATENCIONSINTURNO_LOADING";
export const ATENCIONSINTURNO_SUCCESS = "ATENCIONSINTURNO_SUCCESS";
export const ATENCIONSINTURNO_ERROR = "ATENCIONSINTURNO_ERROR";
export const ATENCIONSINTURNO_RESET = "ATENCIONSINTURNO_RESET";

export const PREGUNTASFRECUENTES_LOADING = "PREGUNTASFRECUENTES_LOADING";
export const PREGUNTASFRECUENTES_SUCCESS = "PREGUNTASFRECUENTES_SUCCESS";
export const PREGUNTASFRECUENTES_ERROR = "PREGUNTASFRECUENTES_ERROR";
export const PREGUNTASFRECUENTES_RESET = "PREGUNTASFRECUENTES_RESET";

export const EDITA_TURNOSDISPONIBLES = "EDITA_TURNOSDISPONIBLES";
export const RESET_FILTROSDISPONIBLES = "RESET_FILTROSDISPONIBLES";
export const FINALIZA_TURNOSDISPONIBLES = "FINALIZA_TURNOSDISPONIBLES";

export const MULTITABSINTURNO_SETPASO = "MULTITABSINTURNO_SETPASO";
export const MULTITABSINTURNO_LOGOUT = "MULTITABSINTURNO_LOGOUT";

export const ORDENESTUDIO_LOADING = "ORDENESTUDIO_LOADING";
export const ORDENESTUDIO_SUCCESS = "ORDENESTUDIO_SUCCESS";
export const ORDENESTUDIO_ERROR = "ORDENESTUDIO_ERROR";
export const ORDENESTUDIO_RESET = "ORDENESTUDIO_RESET";
export const ORDENESTUDIO_ELIMINAR = "ORDENESTUDIO_ELIMINAR";

export const ORDENLABORATORIO_LOADING = "ORDENLABORATORIO_LOADING";
export const ORDENLABORATORIO_SUCCESS = "ORDENLABORATORIO_SUCCESS";
export const ORDENLABORATORIO_ERROR = "ORDENLABORATORIO_ERROR";
export const ORDENLABORATORIO_RESET = "ORDENLABORATORIO_RESET";
export const ORDENLABORATORIO_ELIMINAR = "ORDENLABORATORIO_ELIMINAR";

export const TURNOSPACIENTE_LOADING = "TURNOSPACIENTE_LOADING";
export const TURNOSPACIENTE_SUCCESS = "TURNOSPACIENTE_SUCCESS";
export const TURNOSPACIENTE_ERROR = "TURNOSPACIENTE_ERROR";
export const TURNOSPACIENTE_RESET = "TURNOSPACIENTE_RESET";
export const TURNOSPACIENTE_LISTAMULTIMEDIA = "TURNOSPACIENTE_LISTAMULTIMEDIA";
export const TURNOSPACIENTE_PLANKINESIO = "TURNOSPACIENTE_PLANKINESIO";
export const TURNOSPACIENTE_LIMPIAR_PLANKINESIO =
  "TURNOSPACIENTE_LIMPIAR_PLANKINESIO";
export const TURNOSPACIENTE_ESTADOVIDEOLLAMADA =
  "TURNOSPACIENTE_ESTADOVIDEOLLAMADA";
export const TURNOSPACIENTE_ULTIMOTURNO = "TURNOSPACIENTE_ULTIMOTURNO";
export const TURNOSPACIENTE_TIPOTURNO = "TURNOSPACIENTE_TIPOTURNO";
export const TURNOSPACIENTE_TIPOTURNO_RESET = "TURNOSPACIENTE_TIPOTURNO_RESET";
export const TURNOSPACIENTE_CANCELARPLANKINESIO =
  "TURNOSPACIENTE_CANCELARPLANKINESIO";
export const TURNOSPACIENTE_RESET_CANCELARPLANKINESIO =
  "TURNOSPACIENTE_RESET_CANCELARPLANKINESIO";
export const TURNOSPACIENTE_MATRICULAMEDICO = "TURNOSPACIENTE_MATRICULAMEDICO";
export const TURNOSPACIENTE_GUARDAR_MATRICULAMEDICO =
  "TURNOSPACIENTE_GUARDAR_MATRICULAMEDICO";
export const TURNOSPACIENTE_PUT_MATRICULAMEDICO =
  "TURNOSPACIENTE_PUT_MATRICULAMEDICO";
export const TURNOSPACIENTE_LIMPIAR_MATRICULAMEDICO =
  "TURNOSPACIENTE_LIMPIAR_MATRICULAMEDICO";
export const TURNOSPACIENTE_DATOSMEDICO = "TURNOSPACIENTE_DATOSMEDICO";
export const TURNOSPACIENTE_PUT_DATOSMEDICO = "TURNOSPACIENTE_PUT_DATOSMEDICO";
export const TURNOSPACIENTE_LIMPIAR_DATOSMEDICO =
  "TURNOSPACIENTE_LIMPIAR_DATOSMEDICO";
export const TURNOSPACIENTE_CAMBIARESTADO = "TURNOSPACIENTE_CAMBIARESTADO";
export const TURNOSPACIENTE_CAMBIARESTADO_RESET =
  "TURNOSPACIENTE_CAMBIARESTADO_RESET";
export const TURNOSPACIENTE_TURNOSOLICITUD = "TURNOSPACIENTE_TURNOSOLICITUD";
export const TURNOSPACIENTE_RESET_TURNOSOLICITUD =
  "TURNOSPACIENTE_RESET_TURNOSOLICITUD";
export const TURNOSPACIENTE_SUBIDAORDEN_LOADING =
  "TURNOSPACIENTE_SUBIDAORDEN_LOADING";
export const TURNOSPACIENTE_SUBIDAORDEN_LOADING_RESET =
  "TURNOSPACIENTE_SUBIDAORDEN_LOADING_RESET";

export const MERCADOPAGO_LOADING = "MERCADOPAGO_LOADING";
export const MERCADOPAGO_SUCCESS = "MERCADOPAGO_SUCCESS";
export const MERCADOPAGO_ERROR = "MERCADOPAGO_ERROR";
export const MERCADOPAGO_RESET = "MERCADOPAGO_RESET";
export const MERCADOPAGO_REFERENCIA = "MERCADOPAGO_REFERENCIA";
export const MERCADOPAGO_REFERENCIA_LOADING = "MERCADOPAGO_REFERENCIA_LOADING";

export const GRUPOFAMILIAR_LOADING = "GRUPOFAMILIAR_LOADING";
export const GRUPOFAMILIAR_SUCCESS = "GRUPOFAMILIAR_SUCCESS";
export const GRUPOFAMILIAR_ERROR = "GRUPOFAMILIAR_ERROR";
export const GRUPOFAMILIAR_RESET = "GRUPOFAMILIAR_RESET";
export const GRUPOFAMILIAR_AUTORIZAR = "GRUPOFAMILIAR_AUTORIZAR";

export const SEARCH_DNI_FAMILIAR_SUCCESS = "SEARCH_DNI_FAMILIAR_SUCCES";
export const SEARCH_DNI_FAMILIAR_FAIL = "SEARCH_DNI_FAMILIAR_FAIL";
export const SEARCH_DNI_FAMILIAR = "SEARCH_DNI_FAMILIAR";

export const ADD_FAMILIAR_POST = "ADD_FAMILIAR_POST";
export const ADD_FAMILIAR_POST_SUCCESS = "ADD_FAMILIAR_POST_SUCCESS";
export const ADD_FAMILIAR_POST_FAIL = "ADD_FAMILIAR_POST_FAIL";

export const VINCULO_PUT = "VINCULO_PUT";
export const VINCULO_PUT_SUCCESS = "VINCULO_PUT_SUCCESS";
export const VINCULO_PUT_FAIL = "VINCULO_PUT_FAIL";

export const GET_TIPOS_PARENTESCO = "GET_TIPOS_PARENTESCO";
export const GET_TIPOS_PARENTESCO_SUCCESS = "GET_TIPOS_PARENTESCO_SUCCESS";
export const GET_TIPOS_PARENTESCO_FAIL = "GET_TIPOS_PARENTESCO_FAIL";

export const LIMPIAR_ADD_FAMILIAR = "LIMPIAR_ADD_FAMILIAR";

export const LIMPIAR_POST_FAMILIAR = "LIMPIAR_POST_FAMILIAR";

export const LIMPIAR_PUT_FAMILIAR = "LIMPIAR_PUT_FAMILIAR";

export const LIMPIAR_DELETE_FAMILIAR = "LIMPIAR_DELETE_FAMILIAR";

export const DELETE_VINCULO_FAMILIAR = "DELETE_VINCULO_FAMILIAR";
export const DELETE_VINCULO_FAMILIAR_SUCCESS =
  "DELETE_VINCULO_FAMILIAR_SUCCESS";
export const DELETE_VINCULO_FAMILIAR_FAIL = "DELETE_VINCULO_FAMILIAR_FAIL";

export const ADD_FAMILIAR_CON_CLAVE = "ADD_FAMILIAR_CON_CLAVE";
export const ADD_FAMILIAR_CON_CLAVE_SUCCESS = "ADD_FAMILIAR_CON_CLAVE_SUCCESS";
export const ADD_FAMILIAR_CON_CLAVE_FAIL = "ADD_FAMILIAR_CON_CLAVE_FAIL";

export const LIMPIAR_ADD_FAMILIAR_CLAVE = "LIMPIAR_ADD_FAMILIAR_CLAVE";

export const DROPDOWN_LIMPIAR = "DROPDOWN_LIMPIAR";

export const DROPDOWN_SELECT_GLOBAL = "DROPDOWN_SELECT_GLOBAL";
export const DROPDOWN_SELECT_GLOBAL_LIMPIAR = "DROPDOWN_SELECT_GLOBAL_LIMPIAR";

export const DROPDOWN_SELECT_CM = "DROPDOWN_SELECT_CM";
export const DROPDOWN_SELECT_CM_LIMPIAR = "DROPDOWN_SELECT_CM_LIMPIAR";

export const DROPDOWN_SELECT_E = "DROPDOWN_SELECT_E";
export const DROPDOWN_SELECT_E_LIMPIAR = "DROPDOWN_SELECT_E_LIMPIAR";

export const DROPDOWN_SELECT_L = "DROPDOWN_SELECT_L";
export const DROPDOWN_SELECT_L_LIMPIAR = "DROPDOWN_SELECT_L_LIMPIAR";

export const DROPDOWN_SELECT_R = "DROPDOWN_SELECT_R";
export const DROPDOWN_SELECT_R_LIMPIAR = "DROPDOWN_SELECT_R_LIMPIAR";

export const DROPDOWN_SELECT_MILABO = "DROPDOWN_SELECT_MILABO";
export const DROPDOWN_SELECT_MILABO_LIMPIAR = "DROPDOWN_SELECT_MILABO_LIMPIAR";

export const DROPDOWN_SELECT_MI_INFORME = "DROPDOWN_SELECT_MI_INFORME";
export const DROPDOWN_SELECT_MI_INFORME_LIMPIAR =
  "DROPDOWN_SELECT_MI_INFORME_LIMPIAR";

export const DROPDOWN_SELECT_USER_PT = "DROPDOWN_SELECT_USER_PT";
export const DROPDOWN_SELECT_USER_PT_LIMPIAR =
  "DROPDOWN_SELECT_USER_PT_LIMPIAR";
export const DROPDOWN_SELECT_MI_MEDICO = "DROPDOWN_SELECT_MI_MEDICO";
export const DROPDOWN_SELECT_MI_MEDICO_ESP = "DROPDOWN_SELECT_MI_MEDICO_ESP";
export const DROPDOWN_SELECT_MI_MEDICO_LIMPIAR =
  "DROPDOWN_SELECT_MI_MEDICO_LIMPIAR";
export const DROPDOWN_SELECT_PT_LIMPIAR = "DROPDOWN_SELECT_PT_LIMPIAR";

export const EDITAR_DERECHOS = "EDITAR_DERECHOS";
export const EDITAR_DERECHOS_SUCCESS = "EDITAR_DERECHOS_SUCCESS";
export const EDITAR_DERECHOS_FAIL = "EDITAR_DERECHOS_FAIL";

export const DROPDOWN_SELECT_USER_EDITAR_P = "DROPDOWN_SELECT_USER_EDITAR_P";

export const SET_FECHA_TURNOS = "SET_FECHA_TURNOS";

export const SET_TURNOS_DATA = "SET_TURNOS_DATA";

export const GET_TRAER_VIDEOS = "GET_TRAER_VIDEOS";
export const GET_TRAER_VIDEOS_SUCCESS = "GET_TRAER_VIDEOS_SUCCESS";
export const GET_TRAER_VIDEOS_FAIL = "GET_TRAER_VIDEOS_FAIL";
export const GET_TRAER_VIDEOS_LIMPIAR = "GET_TRAER_VIDEOS_LIMPIAR";

export const POST_NOTIFICACION = "POST_NOTIFICACION";
export const POST_NOTIFICACION_SUCCESS = "POST_NOTIFICACION_SUCCESS";
export const POST_NOTIFICACION_FAIL = "POST_NOTIFICACION_FAIL";

export const RESET_NOTIFICACION = "RESET_NOTIFICACION";

export const DISPOSITIVOPACIENTE_LOADING = "DISPOSITIVOPACIENTE_LOADING";
export const DISPOSITIVOPACIENTE_SUCCESS = "DISPOSITIVOPACIENTE_SUCCESS";
export const DISPOSITIVOPACIENTE_ERROR = "DISPOSITIVOPACIENTE_ERROR";
export const DISPOSITIVOPACIENTE_RESET = "DISPOSITIVOPACIENTE_RESET";
export const DISPOSITIVOPACIENTE_FLGVINCULADO =
  "DISPOSITIVOPACIENTE_FLGVINCULADO";

export const DISPOSITIVOPACIENTEDELETE_LOADING =
  "DISPOSITIVOPACIENTEDELETE_LOADING";
export const DISPOSITIVOPACIENTEDELETE_SUCCESS =
  "DISPOSITIVOPACIENTEDELETE_SUCCESS";
export const DISPOSITIVOPACIENTEDELETE_ERROR =
  "DISPOSITIVOPACIENTEDELETE_ERROR";
export const DISPOSITIVOPACIENTEDELETE_RESET =
  "DISPOSITIVOPACIENTEDELETE_RESET";

export const DISPOSITIVOPACIENTEAGREGAR_LOADING =
  "DISPOSITIVOPACIENTEAGREGAR_LOADING";
export const DISPOSITIVOPACIENTEAGREGAR_SUCCESS =
  "DISPOSITIVOPACIENTEAGREGAR_SUCCESS";
export const DISPOSITIVOPACIENTEAGREGAR_ERROR =
  "DISPOSITIVOPACIENTEAGREGAR_ERROR";
export const DISPOSITIVOPACIENTEAGREGAR_RESET =
  "DISPOSITIVOPACIENTEAGREGAR_RESET";

export const DISPOSITIVOPACIENTETRANSFERIR_LOADING =
  "DISPOSITIVOPACIENTETRANSFERIR_LOADING";
export const DISPOSITIVOPACIENTETRANSFERIR_SUCCESS =
  "DISPOSITIVOPACIENTETRANSFERIR_SUCCESS";
export const DISPOSITIVOPACIENTETRANSFERIR_ERROR =
  "DISPOSITIVOPACIENTETRANSFERIR_ERROR";
export const DISPOSITIVOPACIENTETRANSFERIR_RESET =
  "DISPOSITIVOPACIENTETRANSFERIR_RESET";

export const DISPOSITIVOPACIENTEPREFERENCIAS_LOADING =
  "DISPOSITIVOPACIENTEPREFERENCIAS_LOADING";
export const DISPOSITIVOPACIENTEPREFERENCIAS_SUCCESS =
  "DISPOSITIVOPACIENTEPREFERENCIAS_SUCCESS";
export const DISPOSITIVOPACIENTEPREFERENCIAS_ERROR =
  "DISPOSITIVOPACIENTEPREFERENCIAS_ERROR";
export const DISPOSITIVOPACIENTEPREFERENCIAS_RESET =
  "DISPOSITIVOPACIENTEPREFERENCIAS_RESET";

export const PUT_NOTIFICACION = "PUT_NOTIFICACION";
export const PUT_NOTIFICACION_SUCCESS = "PUT_NOTIFICACION_SUCCESS";
export const PUT_NOTIFICACION_FAIL = "PUT_NOTIFICACION_FAIL";

export const ALERTAS_LOADING = "ALERTAS_LOADING";
export const ALERTAS_SUCCESS = "ALERTAS_SUCCESS";
export const ALERTAS_ERROR = "ALERTAS_ERROR";
export const ALERTAS_RESET = "ALERTAS_RESET";

export const PUT_ABM_FAIL = "PUT_ABM_FAIL";

export const SET_ALERTA_MODAL = "SET_ALERTA_MODAL";
export const SET_ALERTA_MODAL_DELETE = "SET_ALERTA_MODAL_DELETE";

export const LABORDENDIGITAL_LOADING = "LABORDENDIGITAL_LOADING";
export const LABORDENDIGITAL_LOAD = "LABORDENDIGITAL_LOAD";
export const LABORDENDIGITAL_SUCCESS = "LABORDENDIGITAL_SUCCESS";
export const LABORDENDIGITAL_ERROR = "LABORDENDIGITAL_ERROR";
export const LABORDENDIGITAL_RESET = "LABORDENDIGITAL_RESET";
export const LABORDENDIGITAL_ALTATURNO_SET = "LABORDENDIGITAL_ALTATURNO_SET";
export const LABORDENDIGITAL_FLGVOLVER = "LABORDENDIGITAL_FLGVOLVER";
export const LABORDENDIGITAL_MEDICO_ORIG_SOLICITANTE = "LABORDENDIGITAL_MEDICO_ORIG_SOLICITANTE";
export const LABORDENDIGITAL_FECHA_SET = "LABORDENDIGITAL_FECHA_SET";

export const ORDENDIGITAL_LOADING = "ORDENDIGITAL_LOADING";
export const ORDENDIGITAL_LOAD = "ORDENDIGITAL_LOAD";
export const ORDENDIGITAL_SUCCESS = "ORDENDIGITAL_SUCCESS";
export const ORDENDIGITAL_ERROR = "ORDENDIGITAL_ERROR";
export const ORDENDIGITAL_RESET = "ORDENDIGITAL_RESET";
export const ORDENDIGITAL_ALTATURNO_SET = "ORDENDIGITAL_ALTATURNO_SET";
export const ORDENDIGITAL_FLGVOLVER = "ORDENDIGITAL_FLGVOLVER";
export const ORDENDIGITAL_SOLICITANTE = "ORDENDIGITAL_SOLICITANTE";
export const ORDENDIGITAL_FECHA_SET = "ORDENDIGITAL_FECHA_SET";
export const ORDENDIGITALGRUPO_SUCCESS = "ORDENDIGITALGRUPO_SUCCESS";
export const ORDENDIGITALPDF_SUCCESS = "ORDENDIGITALPDF_SUCCESS";
export const ORDENDIGITALPDF_LOADING = "ORDENDIGITALPDF_LOADING";
export const ORDENDIGITALPDF_ERROR = "ORDENDIGITALPDF_ERROR";
export const ORDENDIGITALPDF_RESET = "ORDENDIGITALPDF_RESET";

export const LABORDENDIGITAL_GETPDF_LOADING = "LABORDENDIGITAL_GETPDF_LOADING";
export const LABORDENDIGITAL_GETPDF_SUCCESS = "LABORDENDIGITAL_GETPDF_SUCCESS";
export const LABORDENDIGITAL_GETPDF_ERROR = "LABORDENDIGITAL_GETPDF_ERROR";
export const LABORDENDIGITAL_GETPDF_RESET = "LABORDENDIGITAL_GETPDF_RESET";

export const PRESENTISMO_LOADING = "PRESENTISMO_LOADING";
export const PRESENTISMO_SUCCESS = "PRESENTISMO_SUCCESS";
export const PRESENTISMO_ERROR = "PRESENTISMO_ERROR";
export const PRESENTISMO_RESET = "PRESENTISMO_RESET";

export const CAMBIAR_TURNO_LAB_LOADING = "CAMBIAR_TURNO_LAB_LOADING";
export const CAMBIAR_TURNO_LAB_SUCCESS = "CAMBIAR_TURNO_LAB_SUCCESS";
export const CAMBIAR_TURNO_LAB_ERROR = "CAMBIAR_TURNO_LAB_ERROR";
export const CAMBIAR_TURNO_LAB_RESET = "CAMBIAR_TURNO_LAB_RESET";

export const RESET_PORTAL_CONTEXT = "RESET_PORTAL_CONTEXT";
